import React, { useContext, useEffect, useState } from "react";
import { useGeoApps } from "@mapgear/geoapps-ui-framework";
import { FeatureInfoContext } from "./FeatureInfoContext";
import { LayerItemId } from "../types/LayerItemId";

export const TimeSlider = (): JSX.Element => {
    const { geoapps } = useGeoApps();
    const { years } = useContext(FeatureInfoContext);
    const [year, setYear] = useState<number>(1832);
    const [layers, setLayers] = useState<any[]>([]);
    const map = geoapps.GetMap("map");

    /**
     * Init layers
     */
    useEffect(() => {
        if (!map) return;

        // Get layers
        if (layers.length === 0) {
            const plotLayer = map.Layers.Items.filter(layer => layer.LayerItemId === LayerItemId.PLOTS);
            if (plotLayer.length === 0) return;
            setLayers(plotLayer[0].ChildLayers);
        }

    }, [map]);

    /**
     * Handle layer filtering
     */
    useEffect(() => {
        if (layers.length === 0) return;

        const searchDelay = setTimeout(() => {
            // Build and apply filter
            const filter = {
                operator: "and",
                filters: [
                    { operator: "<=", attribute: "van", value: year },
                    { operator: ">=", attribute: "tot", value: year },
                ]
            };

            // Apply filter
            layers[0].ApplyFilter2(filter);
        }, 300);

        return () => clearTimeout(searchDelay);

    }, [year, layers])

    /**
     * When the from and until years change, chech if timeslider year value fits between these two years
     */
    useEffect(() => {
        if (!years[0] || !years[1]) return;
        
        if (years[0] > year || years[1] < year) {
            setYear(years[0]);
        }

    }, [years])

    /**
    * Handler for slider 
    */
    const sliderChangeHandler = (e: any) => {
        if (!e.target) return;
        const value = e.target.value;
        setYear(value);
    };

    return (
        <div className="time-slider">
            <div className="year">{year}</div>
            <input
                onChange={sliderChangeHandler}
                title="Dienstjaar"
                id="slider3"
                type="range"
                min="1832"
                max="1966"
                step="1"
                value={year}
                defaultValue={1832}
            />
        </div>
    );
};
